import { render } from "./trainer-modal.vue?vue&type=template&id=98a0bd82"
import script from "./trainer-modal.vue?vue&type=script&lang=js"
export * from "./trainer-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__